import { NumberBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../../state/standardLoanStore';

/** Part of a Custom term (TermInfo decides when it shows). */
export const ContractualExtension1MonthsField = () => {
    const value = useStandardLoanStore((state) => state.setup.contractualExtension1Months);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <NumberBox
            id='setupContractualExtension1Months'
            value={value}
            onChange={(months) => updateSetup({ contractualExtension1Months: months ?? undefined })}
            label='Ext. 1 (mo.)'
            min={0}
            max={999}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='80px'
        />
    );
};
